/* eslint-disable jsdoc/require-example */
import axios from 'axios';

/**
 * @description Get the ajax info from the data-ajax-url attribute,
 *  and inject the response form tha call into the target.
 */
export default class AjaxUrlHtml {
    /**
     * @description We get the info from
     * the domElement and it's also the target.
     * @param {HTMLElement} domElement - Target of injection with ajax info.
     */
    constructor(domElement) {
        this.domElement = domElement;
        this.init();
    }

    /**
     * @description Init the module and get the template.
     */
    init() {
        const domElementProperties = AjaxUrlHtml.getDOMElementProps(this.domElement);

        AjaxUrlHtml.getTemplate(domElementProperties.url)
            .then(tpl => AjaxUrlHtml.replaceContent(tpl, domElementProperties.dom));
    }

    /**
     * @description  Create a object with the the element and the target.
     * @param {HTMLElement} domElement - The element with the data-ajax-url.
     * @returns {(object|string)} Object for the ajax call.
     */
    static getDOMElementProps(domElement) {
        return {
            dom: domElement,
            url: domElement.dataset.ajaxUrl
        };
    }

    /**
     * @description Methode that do the Ajax call.
     * @param {URL} url - Url used to make the Ajax call.
     * @returns {string} Template string that will be inject in the dom.
     */
    static getTemplate(url) {
        return axios.get(url).then(resp => resp.data);
    }

    /**
     * @description Inject the template string in the dome.
     * @param  {string} newDOM - Template string to inject.
     * @param  {HTMLElement} container - Target to inject the template string.
     */
    static replaceContent(newDOM, container) {
        if(container.dataset.ajaxUrlReplaced === 'true') {
            return;
        }

        const injectionTarget = container;

        injectionTarget.innerHTML = newDOM;
        injectionTarget.dataset.ajaxUrlReplaced = true;
    }
}
